module.exports = __webpack_public_path__ + "img/index3_2.4ed6557.png";